import { CampaignVisibilityConfig } from '../store/schema/CampaignVisibilityConfig';
import { store } from 'owa-lightning-core-v2';

/**
 * Based on the visibility configuration determines if a campaign is visible or not
 * @param visibilityConfig
 */
export const isCampaignVisible = (visibilityConfig: CampaignVisibilityConfig) => {
    const { lightningId, rule } = visibilityConfig;
    let lightningVisible: boolean = true;

    if (lightningId) {
        const lightningViewState = store.unseenItems.get(lightningId);
        lightningVisible = !!lightningViewState && lightningViewState.visible;
    }

    return lightningVisible && !!rule && rule();
};
